import React from 'react';
import { ProtectedPermissionRoute, ProtectedAdminRoute } from '@nimbitlabs/auth';
import UserManagement from './UserManagement';
import { ApiKeysPage } from './ApiKeysPage';

export const userRoutes = [
  { 
    path: '/users', 
    element: <ProtectedAdminRoute><ProtectedPermissionRoute element={<UserManagement />} permission="users:read" /></ProtectedAdminRoute>, 
    permission: 'users:read' 
  },
  { 
    path: '/api-keys', 
    element: <ProtectedAdminRoute><ProtectedPermissionRoute element={<ApiKeysPage />} permission="api_keys:read" /></ProtectedAdminRoute>, 
    permission: 'api_keys:read' 
  },
];
